import { useState, useEffect } from "react";
import Loader from "./Loader";

/**
 * FINAL GlobalLoader for Imago
 * - Always centered fullscreen overlay
 * - Never appears inside content
 * - Auto hides correctly
 */
const GlobalLoader = () => {
  const [loading, setLoading] = useState(Boolean(window.loading));

  useEffect(() => {
    const update = () => setLoading(Boolean(window.loading));

    window.addEventListener("loading-change", update);

    const interval = setInterval(update, 150);

    return () => {
      window.removeEventListener("loading-change", update);
      clearInterval(interval);
    };
  }, []);

  if (!loading) return null;

  return (
    <Loader
      fullscreen={true}
      size={70}
      text=""
    />
  );
};

export default GlobalLoader;
